const urlPattern = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;

export const validateLinks = (values) => {
  return values.map((link, idx) => {
    if (link.type === 'other') {
      if (!link.title) {
        return { idx, error: "Title is required", name: "title" };
      }
    }

    if (!link.type) {
      return { idx, error: "Type is required", name: "type" };
    }

    if (!link.url) {
      return { idx, error: "URL is required", name: "url" };
    }
    if (!urlPattern.test(link.url)) {
      return { idx, error: "Invalid URL", name: "url" };
    }

    if (link.type === 'google_scholar') {
       // check if url is a google scholar profile url
       if (!link.url.includes('scholar.google')) {
        return { idx, error: "Invalid Google Scholar URL", name: "url" };
       }
    }

    if (link.type === 'research_gate') {
      if (!link.url.includes('researchgate.net')) {
        return { idx, error: "Invalid Research Gate URL", name: "url" };
      }
    }

    if (link.type === 'dribbble') {
      if (!link.url.includes('dribbble.com')) {
        return { idx, error: "Invalid Dribbble URL", name: "url" };
      }
    }

    if (link.type === 'github') {
      if (!link.url.includes('github.com')) {
        return { idx, error: "Invalid GitHub URL", name: "url" };
      }
    }
    
    return null;
  }).filter(error => error)
};
